import { Play, Pause, Coins, Check } from 'lucide-react';
import { usePlayer } from '../context/PlayerContext';
import { Link } from 'react-router-dom';

export const TrackCard = ({ track, tracks = [], showTokens = false }) => {
  const { currentTrack, isPlaying, playTrack, pause } = usePlayer();
  const isCurrentTrack = currentTrack?.id === track.id;

  const handlePlay = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isCurrentTrack && isPlaying) {
      pause();
    } else {
      playTrack(track, tracks.length > 0 ? tracks : [track]);
    }
  };

  return (
    <Link 
      to={`/track/${track.id}`}
      className="glass-card p-4 card-hover group block cursor-pointer"
      data-testid={`track-card-${track.id}`}
    >
      <div className="relative aspect-square mb-4 rounded-lg overflow-hidden">
        <img 
          src={track.cover_url} 
          alt={track.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <button
            onClick={handlePlay}
            className="w-14 h-14 rounded-full bg-purple-500 flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
            data-testid={`play-track-${track.id}`}
          >
            {isCurrentTrack && isPlaying ? (
              <Pause className="w-6 h-6 text-white" />
            ) : (
              <Play className="w-6 h-6 text-white ml-1" />
            )}
          </button>
        </div>
        {isCurrentTrack && isPlaying && (
          <div className="absolute bottom-2 left-2 px-2 py-1 rounded bg-purple-500/80 text-xs font-medium">
            Now Playing
          </div>
        )}
        {track.is_owned && (
          <div
            className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] font-bold uppercase tracking-wider shadow-lg shadow-green-500/40"
            data-testid={`track-owned-badge-${track.id}`}
          >
            <Check className="w-3 h-3" /> Owned
          </div>
        )}
      </div>

      <h3 className="font-semibold text-white truncate mb-1" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        {track.title}
      </h3>
      <p className="text-sm text-gray-400 truncate mb-3">{track.album || 'Single'}</p>

      <div className="flex items-center justify-between">
        <span className={`font-medium subheading ${track.is_owned ? 'text-green-400' : 'text-purple-400'}`}>
          {track.is_owned ? 'In your library' : `$${track.price.toFixed(2)}`}
        </span>
        {showTokens && (
          <div className="flex items-center gap-1 text-cyan-400">
            <Coins className="w-4 h-4" />
            <span className="text-sm font-medium token-data">{track.available_tokens}%</span>
          </div>
        )}
      </div>
    </Link>
  );
};
